<template>
    <div :class="{card:!this.$store.state.isMobile,mcard:this.$store.state.isMobile}">
        <div class="address" v-if="!showfrom">
            <div
                class="item"
                :class="i==active1?'bg':'border'"
                v-for="(item,i) in msg"
                :key="i"
                @click="address(i)">
                <img
                    :src="i==active1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                    alt
                />
                <div class="msg">
                    <div v-for="(value,index) in fromlist" :key="index">
                        <div class="title" v-if="!value.hidden && item[value.key]">
                            <span v-if="only && index==0">VISA</span>
                            <span v-if="!value.hidden && !value.only && item[value.key]"
                                  class="font14">{{ value.title }}</span>
                            <p class="font14 point" @click="edit(i)" v-if="index==0">Modifier</p>
                        </div>
                        <div class="detalis font14" v-if="only && index==0">{{ encryption(item[value.key]) }}</div>
                        <div v-else>
                            <div class="detalis font14" v-if="!value.hidden">
                                <!-- <p
                                  v-if="only"
                                >{{index<2 ? item[value.key]:item[fromlist[3].key]+item[fromlist[2].key]}}</p> -->
                                <p v-if="item[value.key]">{{ item[value.key] }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="addbtn" @click="addcarte">
                <button class="btn">{{ langPage['v4-choosecarte']['TXT_utiliseruneniuvelleadress'] }}</button>
            </div>
        </div>

        <div class="from" v-if="showfrom">
            <div class="tips" v-if="tipsbool">
                <img src="@/assets/img/Radio-on.svg" alt/>
                {{ langPage['v4-choosecarte']['TXT_utilisationdunenouvelleadressedelive'] }}
            </div>
            <el-form
                label-position="top"
                ref="formlist"
                :rules="rules"
                :model="formdata"
                :hide-required-asterisk="true"
                class>
                <el-form-item
                    :prop="value.key"
                    :label="value.title"
                    v-for="(value,index) in fromlist"
                    :key="index"
                    v-if="!value.onlyShow">
                    <el-input
                        :hide-required-asterisk="false"
                        :type="value.type?value.type:'text'"
                        v-model="formdata[value.key]"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="langPage['v4-entreprise']['TXT_choisissezunpays']">
                    <el-select v-model="formdata.id_pays" placeholder="">
                        <el-option
                            v-for="item in nations"
                            :key="item.id_pays"
                            :label="item.texte_fr"
                            :value="item.id_pays"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="eori*"
                              v-if="formdata.id_pays==24"
                              prop="eori">
                    <el-input class="input" v-model="formdata['eori']"></el-input>
                </el-form-item>
            </el-form>
            <div class="pour" v-if="showfrom && only">
                <el-checkbox v-model="checked">{{
                        langPage['v4-choosecarte']['TXT_enregistrerpourplustard']
                    }}
                </el-checkbox>
                <p>{{ langPage['v4-choosecarte']['TXT_vosdetailsdepaiement'] }}</p>
            </div>

            <el-button class="cancel" @click="cancel">{{
                    langPage['v4-choosecarte']['TXT_annulernouvelleadresse']
                }}
            </el-button>
            <el-button class="sub" @click="sub">{{ langPage['v4-choosecarte']['TXT_submit'] }}</el-button>
        </div>
    </div>
</template>
<script>
import {mapState} from "vuex";

export default {
    name: "chooseCarte",
    props: {
        fromlist: {
            type: Array,
            default: () => {
            }
        },
        msg: {
            type: Array,
            default: () => []
        },
        tipsbool: {
            type: Boolean,
            default: false
        },
        only: {
            type: Boolean,
            default: false
        },
        addressType: {
            type: Number,
            require: true,
            default: 1
        }
    },
    computed: {

        langPage() {
            return this.$store.state['langPage']
        }
    },
    data() {
        return {
            active1: 0,
            formdata: {id_pays: '', eori: ''},
            rules: {
                id_pays: [{required: true, message: "need choisissez un pays", trigger: "blur"}]
            },
            showfrom: false,
            checked: false,
            editType: 0,//0编辑  1新建
            editIndex: 0,//目前编辑的地址的角标
            nations: [],//国家信息
        };
    },
    mounted() {
        let keys = Object.keys(this.fromlist);
        for (var i of keys) {
            if (!this.fromlist[i].onlyShow) {//只提供显示，不进行编辑修改 only show,no edit
                this.rules[this.fromlist[i].key] = this.fromlist[i].rule;
                this.$set(this.formdata, this.fromlist[i].key, "");
            }
        }
        this.formdata.eori = this.$store.state.userInfo.eori;
        this.fetchNations();
    },
    methods: {
        address(i) {
            let item = this.msg[i];
            if (item.id_pays==24 && !this.formdata.eori) return this.$message.error(this.$t('chooseCarte.word2'))
            this.active1 = i;
            this.$emit('chooseAddress', i);
        },
        addcarte() {
            this.editType = 1;
            this.showfrom = true;
        },
        edit(i) {
            for (let key in this.formdata) {
                if (key == 'eori') continue;
                this.formdata[key] = this.msg[i][key];
            }
            this.editType = 0;
            this.editIndex = i;
            this.showfrom = true;
        },
        cancel() {
            for (var i in this.fromlist) {
                this.$set(this.formdata, this.fromlist[i].key, "");
            }
            this.showfrom = false;
        },
        sub() {
            if (this.formdata.id_pays == 24 && !this.formdata.eori) return this.$message.error(this.$t('chooseCarte.word1'));
            this.$refs.formlist.validate(valid => {
                if (valid) {
                    this.formdata.type = this.addressType;
                    this.formdata.id_adresse = this.msg[this.editIndex]['id_adresse'];
                    this.formdata.id_acheteur = localStorage.getItem('id_acheteur');
                    if (this.editType == 0) {   //编辑  先删再添加
                        this.deleAddress(this.formdata)
                    } else {   //新增
                        this.addAddress(this.formdata)
                    }
                } else {
                    console.log("error submit!!");
                    return;
                }
            });
        },
        encryption(str) {
            return new Array(str.length).join("*") + str.substr(-2);
        },
        //删除地址
        deleAddress(data) {
            this.$api.info.deleAddress(data).then(res => {
                this.addAddress(data)
            }).catch(err => {
            })
        },
        addAddress(data) {
            delete this.formdata.id_adresse;
            this.$api.info.addAddress(data).then(res => {
                this.$router.go(0)
            })
        },
        //获取国家信息
        fetchNations() {
            this.$api.info.getNations().then(res => {
                this.nations = res;
                this.formdata.id_pays = this.nations[0].id_pays
            }).catch(err => {
                console.log(err)
            })
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Checkout/transport/chooseCarte.less">
</style>
